/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Component, OnInit, Input, Output, EventEmitter, ViewChild, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

import { AutomateFilter } from '../models';

import { SourceService } from '../../services/source.service';
import { GlobalMessageService } from '../../services/global-message.service';

@Component({
  selector: 'source-filter',
  templateUrl: './source-filter.component.html'
})
export class SourceFilterComponent implements OnInit {

  @Input()
  filter: AutomateFilter;

  @Output('onChange')
  onChange: EventEmitter<AutomateFilter> = new EventEmitter<AutomateFilter>();

  @ViewChild('sourceDialog') sourceDialog: TemplateRef<any>;

  sourceDialogRef: BsModalRef;

  sources: any[] = [];
  sourceDDSettings: any = {
    singleSelection: true,
    groupBy: true,
    text: 'Select source',
    enableSearchFilter: true,
    badgeShowLimit: 1,
    maxHeight: 260
  };

  emailAddressCategoryLabel = 'Email Address';
  domainCategoryLabel = 'Domain';
  newSourceLabel: string = '[ Add New ]';
  newSource: string = '';

  addingFilter: boolean = false;
  addFormValid: boolean = false;
  currentFilterType: string = 'include';
  selectedFilterValue: any[] = [];
  loadingSources: boolean = false;

  constructor(private sourceService: SourceService,
    private globalMessageService: GlobalMessageService,
    private modalService: BsModalService) { }

  ngOnInit() {
    this.loadingSources = true;
    this.sourceService.getSources(0).subscribe(
      (result: any) => {
        // some accounts with a subdomain connected end up with thousands of
        // sources that don't make sense (ie. DUP-aLongNumberHash@domain.com)
        // so we are only going to show sources that have 0 or >1 emails
        // associated with them.
        // 0 because it was manually added to our system
        // >1 because the source is a fluke if there is only 1'

        // only do this if the source count is > then some arbitrary number (reduce impact on most customers)
        if (result.length > 500) {
          result = result.filter(r => r.count != 1);
        }
        this.initSources(result);
      },
      error => {
      }
    );

    this.sourceService.getDomains().subscribe(
      (result: any) => {
        this.initDomains(result);
        this.loadingSources = false;
      },
      error => {

      });
  }

  sourceChange(item) {
    this.sourceChangeInternal();
  }

  addFilter() {
    // check for duplicate before adding
    if (this.filter[this.currentFilterType].findIndex(f => { return f == this.selectedFilterValue[0].itemName }) < 0) {
      this.filter[this.currentFilterType].push(this.selectedFilterValue[0].itemName);
      this.onChange.emit(this.filter);
    }
    this.addFormValid = false;
    this.addingFilter = false;
    this.selectedFilterValue = [];
  }

  cancelAddFilter() {
    this.selectedFilterValue = [];
    this.addingFilter = false;
    this.addFormValid = false;
  }

  removeFilter(type: string, value: string) {
    this.filter[type].splice(this.filter[type].indexOf(value), 1);
    this.onChange.emit(this.filter);
  }

  addSource() {
    this.sourceDialogRef.hide();
    let existingIndex = this.sources.findIndex(s => { return s.itemName == this.newSource });
    if (existingIndex >= 0) {
      // duplicate source - just select it and move on
      this.filter[this.currentFilterType].push(this.sources[existingIndex].itemName);
      this.onChange.emit(this.filter);
      this.globalMessageService.message('Existing source was found in your account and automatically added to your filters');
      this.newSource = '';
    }
    else {
      // new source - save, refresh, and select the newly added source
      this.sourceService.saveSource(this.newSource).subscribe(
        (result: any) => {
          this.sources.push({
            id: result._id,
            itemName: result.email_address,
            category: this.emailAddressCategoryLabel
          });

          let newDomainEntry = { id: result.domain, itemName: result.domain, category: this.domainCategoryLabel };
          if (this.sources.findIndex((d) => d.id == newDomainEntry.id) < 0) {
            this.sources.push(newDomainEntry);
          }
          this.sortSources();
          let newIndex = this.sources.findIndex(s => { return s.itemName == this.newSource });
          this.filter[this.currentFilterType].push(this.sources[newIndex].itemName);
          this.onChange.emit(this.filter);
          this.globalMessageService.message('New source was saved and automatically added to your filters');
          this.newSource = '';
        },
        error => {

        }
      )
    }
  }

  private sourceChangeInternal() {
    if (this.selectedFilterValue[0].itemName == this.newSourceLabel) {
      this.addFormValid = false;
      this.addingFilter = false;
      this.selectedFilterValue = [];
      this.sourceDialogRef = this.modalService.show(this.sourceDialog);
    }
    else {
      this.addFormValid = true;
    }
  }

  private initSources(src: any) {
    this.sources = this.sources.concat(src.map(s => {
      return { id: s._id, itemName: s.email_address, category: this.emailAddressCategoryLabel };
    }));

    this.sources.unshift({
      id: this.newSourceLabel, itemName: this.newSourceLabel, category: this.emailAddressCategoryLabel
    });

    this.sortSources();
  }

  private initDomains(domains: any) {
    this.sources = this.sources.concat(domains.map(d => {
      return { id: d, itemName: d, category: this.domainCategoryLabel };
    }));

    this.sortSources();
  }

  private sortSources() {
    this.sources.sort((a, b) => {
      if (a.id == this.newSourceLabel) {
        return -1;
      }
      else if (a.itemName > b.itemName) {
        return 1;
      }
      else {
        return 0;
      }
    });
  }

}



// WEBPACK FOOTER //
// ./client/app/global/source-filter/source-filter.component.ts